<template>

    <v-modal title="Create Company">
        <template #body>
            <v-alert :message="error" />
            <form @submit.prevent="createCompany">
                <v-form-group dir="ver" label="Company Name">
                    <v-input placeholder="My Company Name" :model="params.name" @input="params.name = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createCompany">Create Company</v-button>
        </template>
    </v-modal>

</template>

<script>

import UserApi from '@api/UserApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        createCompany() {
            this.loading = true;
            UserApi.createCompany(this.params)
                .then((response) => {
                    if (this.$route.name === 'projects') {
                        this.$router.go();
                    } else {
                        this.loading = false;
                        this.$store.commit('showModal', false);
                        this.$router.push({ name: 'projects' });
                    }
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    }

}

</script>
